module.exports = __webpack_public_path__ + "static/media/patentInvestigacion.b245a4d0.png";